define('post-editor/font-plugin',['post-editor/sidebar-api'], function(api) {
	api.defineGroups('*', [ function(editor) {
		var fontsize = editor.buttons.fontsizeselect();
		fontsize.text = '13'; // this is the default

		return {
			title: 'Schriftgröße',
			type: 'toolbar',
			items: [
				fontsize
			]
		};
	}]);
});

